import {formatarCompetencia} from "../../shared/ocorrenciaTemporalUtil";

function protegerCelula(valor) {
    const texto = valor === null || valor === undefined ? "" : String(valor);
    return /^[=+\-@]/.test(texto) ? `'${texto}` : texto;
}

function celulaCsv(valor) {
    const texto = protegerCelula(valor).replace(/"/g, '""');
    return `"${texto}"`;
}

function linha(...valores) {
    return valores.map(celulaCsv).join(";");
}

function secao(titulo, cabecalhos, registros) {
    return [
        linha(titulo),
        linha(...cabecalhos),
        ...registros.map((registro) => linha(...registro)),
        ""
    ];
}

export function criarCsvDashboard(dados, {incluirFolha = true} = {}) {
    const folha = dados.folha || {};
    const linhas = [
        linha("Dashboard de envios do conector e-Sfinge"),
        ...(dados.competencia
            ? [
                  linha("Buscar por", "Competência"),
                  linha("Competência", formatarCompetencia(dados.competencia)),
                  linha("Primeiro registro encontrado", dados.dataInicial),
                  linha("Último registro encontrado", dados.dataFinal)
              ]
            : [
                  linha("Buscar por", "Período de registro"),
                  linha("Período inicial", dados.dataInicial),
                  linha("Período final", dados.dataFinal)
              ]),
        linha(
            "Critério",
            "Canceladas permanecem no histórico e não compõem conclusões vigentes, registros processados ou valores. Solicitações de cancelamento são acompanhadas na lista de ocorrências."
        ),
        "",
        ...secao(
            "Indicadores consolidados",
            ["Indicador", "Quantidade"],
            [
                ["Operações", dados.totalOperacoes],
                ["Etapas", dados.totalEtapas],
                ["Registros processados", dados.registrosProcessados],
                ["Concluídas vigentes", dados.concluidas],
                ["Canceladas", dados.canceladas || 0],
                ["Aguardando revisão", dados.aguardandoRevisao],
                ["Em processamento", dados.emAndamento],
                ["Com atenção", dados.comAtencao]
            ]
        ),
        ...secao(
            "Destinos",
            ["Destino", "Quantidade"],
            (dados.destinos || []).map((item) => [item.rotulo, item.quantidade])
        ),
        ...secao(
            "Estados",
            ["Estado", "Quantidade"],
            (dados.estados || []).map((item) => [item.rotulo, item.quantidade])
        ),
        ...secao(
            "Módulos",
            ["Módulo", "Quantidade"],
            (dados.modulos || []).map((item) => [item.rotulo, item.quantidade])
        ),
        ...secao(
            "Série temporal por data de registro",
            [
                "Período",
                "e-Sfinge direto",
                "Fornecedor",
                "Outros",
                "Concluídas vigentes",
                "Com atenção",
                "Canceladas"
            ],
            (dados.serieTemporal || []).map((item) => [
                item.rotulo,
                item.esfingeDireto,
                item.fornecedor,
                item.outros,
                item.concluidas,
                item.comAtencao,
                item.canceladas || 0
            ])
        ),
        ...(incluirFolha
            ? [
                  ...secao(
                      "Folhas concluídas",
                      ["Indicador", "Valor"],
                      [
                          ["Folhas", folha.folhasConcluidas || 0],
                          ["Servidores", folha.servidores || 0],
                          ["Lançamentos", folha.lancamentos || 0],
                          ["Proventos", folha.proventos || 0],
                          ["Descontos", folha.descontos || 0],
                          ["Líquido", folha.liquido || 0]
                      ]
                  ),
                  ...secao(
                      "Valores da folha por destino",
                      [
                          "Destino",
                          "Folhas",
                          "Proventos",
                          "Descontos",
                          "Líquido"
                      ],
                      (folha.porDestino || []).map((item) => [
                          item.rotulo,
                          item.folhasConcluidas,
                          item.proventos,
                          item.descontos,
                          item.liquido
                      ])
                  ),
                  ...secao(
                      "Valores da folha por grupo de beneficiários",
                      [
                          "Grupo",
                          "Folhas",
                          "Beneficiários",
                          "Lançamentos",
                          "Proventos",
                          "Descontos",
                          "Líquido"
                      ],
                      (folha.porCategoria || []).map((item) => [
                          item.rotulo,
                          item.folhasConcluidas,
                          item.servidores,
                          item.lancamentos,
                          item.proventos,
                          item.descontos,
                          item.liquido
                      ])
                  )
              ]
            : []),
        ...secao(
            "Eventos mais frequentes",
            [
                "Evento",
                "Módulo",
                "Quantidade",
                "Concluídas vigentes",
                "Com atenção",
                "Canceladas"
            ],
            (dados.eventos || []).map((item) => [
                item.evento,
                item.modulo,
                item.quantidade,
                item.concluidas,
                item.comAtencao,
                item.canceladas || 0
            ])
        )
    ];

    return `\uFEFF${linhas.join("\r\n")}`;
}

export function baixarCsvDashboard(dados, opcoes) {
    const conteudo = criarCsvDashboard(dados, opcoes);
    const blob = new Blob([conteudo], {type: "text/csv;charset=utf-8"});
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = dados.competencia
        ? `dashboard-envios-competencia-${dados.competencia}.csv`
        : `dashboard-envios-${dados.dataInicial}-${dados.dataFinal}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
